import React from "react";
import Discussions from './discussions/Discussions';
import DiscussionsDetail from './discussions/DiscussionsDetail';
import Videos from './videos/Videos';
import Tools from './tools/Tools';
import Weekbyweek from './tools/week-by-week/Weekbyweek';
import FetalDevelopmentVideo from './tools/fetus-video/FetalDevelopmentVideo';
import BabySizeComparison from './tools/baby-size-comparison/BabySizeComparison';
import Pis from './tools/pis/Pis';
import PisInfo from './tools/pis/PisInfo';
import PisManageReport from './tools/pis/PisManageReport';
import PisUpdateDetail from './tools/pis/PisUpdateDetail';
import PisManageReminder from './tools/pis/PisManageReminder';
import DietplanMom from './tools/DietplanMom/DietplanMom';
import Dietplan from './tools/baby-dietplan/Dietplan';
import BabyTeething from './tools/baby-teething/BabyTeething';
import BabyTeethingDetails from './tools/baby-teething/AddToothDetails';
import Breastfeeding from './tools/Breastfeeding/Breastfeeding';
import Fetalmovementtracker from './tools/fetal-movement-tracker/Fetal';
import Duedate from './tools/Duedate/DueDate';
import DueDateDetails from './tools/Duedate/DueDateDetails';
import DuedateDisclaimer from './tools/Duedate/Disclaimer';
import DuedateFaqs from './tools/Duedate/Faqs';
import PregnancyGuide from './tools/pregnancyGuide/PregnancyGuide';
import FacebookLiveFeed from './facebook-live-feed/FacebookLiveFeed';
import SessionDetails from './facebook-live-feed/SessionDetails';
import QuickRead from './quick-reads/QuickRead';
import QuickDetails from './quick-reads/QuickDetails';


import MealPlannerLanding from './tools/meal-planner/MealPlannerLanding';
import Recipe from './tools/meal-planner/Recipe';
import Recipedetails from './tools/meal-planner/Recipedetails';
import GroceryList from './tools/meal-planner/GroceryList';
import Reviews from './tools/meal-planner/Reviews';
import RecipeUpload from './tools/meal-planner/RecipeUpload';
import MealPlannerFeedback from './tools/meal-planner/MealPlannerFeedback';
import MealPlannerDisclaimer from './tools/meal-planner/MealPlannerDisclaimer';
import SearchResult from './header/universal-search/SearchResult';

import BabyPhotoContest from './baby-photo-contest/BabyPhotoContest';
import ContestDetails from './baby-photo-contest/ContestDetails';
import HowItWorks from './baby-photo-contest/HowItWorks';
import TermsAndConditions from './baby-photo-contest/TermsAndConditions';
import Leaderboard from './baby-photo-contest/Leaderboard';
import MoreWinnersLanding from './baby-photo-contest/MoreWinnersLanding';
import PhotodetDashboard from './baby-photo-contest/PhotodetDashboard';

import ColoringPageLanding from './coloring-page/ColoringPageLanding';
import ColoringDetails from './coloring-page/ColoringDetails';
import ColoringSubCatDetails from './coloring-page/ColoringSubCatDetails';
import ColoringCatDetails from './coloring-page/ColoringCatDetails';
import NoResult from "./coloring-page/common/NoResult";
import DueDateSummary from "./tools/Duedate/DueDateSummary";


import NoPageFound from './errors/NoPageFound';
import MealPlanRouter from "./tools/meal-planner/MealPlanRouter";

import Face from './tools/Face/Face';
import UploadFaces from './tools/Face/UploadFaces';
import SlideShow from "./tools/Face/SlideShow";
import ExpertListing from './expert/ExpertListing';
import ExpertDetail from './expert/ExpertDetail';
import ExpertMemories from './expert/ExpertMemories';
import GrowthTracker from './tools/vaccination-growth-tracker/GrowthTracker';
import VaccinationTracker from './tools/vaccination-growth-tracker/VaccinationTracker';
import Feedback from './tools/vaccination-growth-tracker/Feedback';


const routes = [
  {
    path: "/discussions",
    element: <Discussions />,
    initialAction: Discussions.initialAction,
  },
  {
    path: "/discussions/page/:page",
    element: <Discussions />,
    initialAction: Discussions.initialAction,
  },
  {
    path: "/discussions/t/:title",
    element: <DiscussionsDetail />,
    initialAction: DiscussionsDetail.initialAction,
  },
  {
    path: "/discussions/t/:title/page/:page",
    element: <DiscussionsDetail />,
    initialAction: DiscussionsDetail.initialAction,
  },
  {
    path: "/videos",
    element: <Videos />,
    initialAction: Videos.initialAction,
  },
  {
    path: "/tools",
    element: <Tools />,
    initialAction: Tools.initialAction,
  },
  {
    path: "/tools/pregnancy-week-by-week-tracker",
    element: <Weekbyweek />,
    initialAction: Weekbyweek.initialAction,
  },
  {
    path: "/tools/fetal-development-video",
    element: <FetalDevelopmentVideo />,
    initialAction: FetalDevelopmentVideo.initialAction,
  },
  {
    path: "/tools/baby-size-comparison",
    element: <BabySizeComparison />,
    initialAction: BabySizeComparison.initialAction,
  },
  {
    path: "/tools/pregnancy-checkup-schedule",
    element: <Pis />,
    initialAction: Pis.initialAction,
  },
  {
    path: "/tools/pregnancy-checkup-schedule/how-it-work",
    element: <PisInfo />,
    initialAction: PisInfo.initialAction,
  },
  {
    path: "/tools/pregnancy-checkup-schedule/manageReports/:title/:id",
    element: <PisManageReport />,
    initialAction: PisManageReport.initialAction,
  },
  {
    path: "/tools/pregnancy-checkup-schedule/updateDetails/:title/:id",
    element: <PisUpdateDetail />,
    initialAction: PisUpdateDetail.initialAction,
  },
  {
    path: "/tools/pregnancy-checkup-schedule/manageReminder/:id/:title",
    element: <PisManageReminder />,
    initialAction: PisManageReminder.initialAction,
  },
  {
    path: "/tools/pregnancy-diet-plan/",
    element: <DietplanMom />,
    initialAction: DietplanMom.initialAction,
  },
  {
    path: "/tools/baby-kids-diet-plan/",
    element: <Dietplan />,
    initialAction: Dietplan.initialAction,
  },
  {
    path: "/tools/baby-teething",
    element: <BabyTeething />,
    initialAction: BabyTeething.initialAction,
  },
  {
    path: "/tools/baby-teething/:any",
    element: <BabyTeethingDetails />,
    initialAction: BabyTeethingDetails.initialAction,
  },
  {
    path: "/tools/breastfeeding-tracker",
    element: <Breastfeeding />,
    initialAction: Breastfeeding.initialAction,
  },
  {
    path: "/tools/fetal-movement-tracker",
    element: <Fetalmovementtracker />,
    initialAction: Fetalmovementtracker.initialAction,
  },
  {
    path: "/tools/pregnancy-due-date-calculator/",
    element: <Duedate />,
    initialAction: Duedate.initialAction,
  },
  {
    path: "/due-date-summary",
    element: <DueDateSummary />,
    initialAction: DueDateSummary.initialAction,
  },
  {
    path: "/tools/pregnancy-due-date-calculator/details",
    element: <DueDateDetails />,
    initialAction: DueDateDetails.initialAction,
  },
  {
    path: "/tools/pregnancy-due-date-calculator/details/:ldate/:cycle/:cdate/:days",
    element: <DueDateDetails />,
    initialAction: DueDateDetails.initialAction,
  },
  {
    path: "/tools/pregnancy-due-date-calculator/details/:ldate/:cycle/:cdate",
    element: <DueDateDetails />,
    initialAction: DueDateDetails.initialAction,
  },
  {
    path: "/tools/pregnancy-due-date-calculator/details/:ldate/:cycle",
    element: <DueDateDetails />,
    initialAction: DueDateDetails.initialAction,
  },
  {
    path: "/tools/pregnancy-due-date-calculator/disclaimer",
    element: <DuedateDisclaimer />,
    initialAction: DuedateDisclaimer.initialAction,
  },
  {
    path: "/tools/pregnancy-due-date-calculator/faqs",
    element: <DuedateFaqs />,
    initialAction: DuedateFaqs.initialAction,
  },
  {
    path: "/tools/pregnancy-week-by-week-guide/",
    element: <PregnancyGuide />,
    initialAction: PregnancyGuide.initialAction,
  },
  {
    path: "/live-sessions",
    element: <FacebookLiveFeed />,
    initialAction: FacebookLiveFeed.initialAction,
  },
  {
    path: "/live-sessions/:any/:any",
    element: <SessionDetails />,
    initialAction: SessionDetails.initialAction,
  },
  {
    path: "/quick-reads/",
    element: <QuickRead />,
    initialAction: QuickRead.initialAction,
  },
  {
    path: "/quick-reads/:type/:title/:id",
    element: <QuickDetails />,
    initialAction: QuickDetails.initialAction,
  },
  {
    path: "/tools/baby-meal-plan/",
    element: <MealPlannerLanding />,
    initialAction: MealPlannerLanding.initialAction,
  },
  {
    path: "/tools/baby-meal-plan/bookmarks/",
    element: <Recipe />,
    initialAction: Recipe.initialAction,
  },
  {
    path: "/tools/baby-meal-plan/feedback",
    element: <MealPlannerFeedback />,
    initialAction: MealPlannerFeedback.initialAction,
  },
  {
    path: "/tools/baby-meal-plan/disclaimer",
    element: <MealPlannerDisclaimer />,
    initialAction: MealPlannerDisclaimer.initialAction,
  },
  // {
  //   path: "/tools/baby-meal-plan/:any",
  //   element: <Recipedetails />,
  //   initialAction: Recipedetails.initialAction,
  // },
  // {
  //   path: "/tools/baby-meal-plan/:any-recipes",
  //   element: <Recipe />,
  //   initialAction: Recipe.initialAction,
  // },
  {
    path: "/tools/baby-meal-plan/:any",
    element: <MealPlanRouter />,
  },  
  {
    path: "/tools/baby-meal-plan/:any/reviews",
    element: <Reviews />,
    initialAction: Reviews.initialAction,
  },
  {
    path: "/tools/baby-meal-plan/grocery-list",
    element: <GroceryList />,
    initialAction: GroceryList.initialAction,
  },
  {
    path: "/tools/baby-meal-plan/upload-recipe",
    element: <RecipeUpload />,
    initialAction: RecipeUpload.initialAction,
  },
  // {
  //   path: /^([\/]tools\/baby-meal-plan\/w*(?!(\w*|\w*-\w*)-recipes|bookmarks|grocery-list|disclaimer|feedback|upload-recipe|\b.*\/reviews).+)/,
  //   element: <Recipedetails />,
  //   initialAction: Recipedetails.initialAction,
  // },
  {
    path: "/search-result/:any/:any",
    // path: /^\/search-result\/\w*[a-zA-Z0-9._-]+\/\w*[a-zA-Z0-9._-]+$/,
    element: <SearchResult />,
    initialAction: SearchResult.initialAction,
  },
  {
    path: "/baby-photo-contest",
    element: <BabyPhotoContest />,
    initialAction: BabyPhotoContest.initialAction,
  },
  {
    path: "/baby-photo-contest/expired",
    element: <BabyPhotoContest />,
    initialAction: BabyPhotoContest.initialAction,
  },
  {
    path: "/baby-photo-contest/active",
    element: <BabyPhotoContest />,
    initialAction: BabyPhotoContest.initialAction,
  },
  {
    path: "/baby-photo-contest/winners",
    element: <BabyPhotoContest />,
    initialAction: BabyPhotoContest.initialAction,
  },
  {
    path: "/baby-photo-contest/contest/:any/leaderboard/:any",
    element: <Leaderboard />,
    initialAction: Leaderboard.initialAction,
  },
  {
    path: "/baby-photo-contest/contest/:any/entries/:any",
    element: <Leaderboard />,
    initialAction: Leaderboard.initialAction,
  },
  {
    path: "/baby-photo-contest/contest/:any/winners/:any",
    element: <MoreWinnersLanding />,
    initialAction: MoreWinnersLanding.initialAction,
  },
  {
    path: "/baby-photo-contest/contest/:title/:id",
    element: <ContestDetails />,
    initialAction: ContestDetails.initialAction,
  },
  {
    path: "/baby-photo-contest/howItWorks/:id/",
    element: <HowItWorks />,
    initialAction: HowItWorks.initialAction,
  },
  {
    path: "/baby-photo-contest/termsAndConditions/:id/",
    element: <TermsAndConditions />,
    initialAction: TermsAndConditions.initialAction,
  },
  {
    path: "/baby-photo-contest/photodetails/:any/:any",
    element: <PhotodetDashboard />,
    initialAction: PhotodetDashboard.initialAction,
  },
  {
    path: "/coloring-pages-printables/",
    element: <ColoringPageLanding />,
    initialAction: ColoringPageLanding.initialAction,
  },
  {
    path: "/coloring-pages-printables/no-result-found/",
    element: <NoResult />,
    initialAction: NoResult.initialAction,
  },
  {
    path: "/coloring-pages-printables/:any/",
    element: <ColoringCatDetails />,
    initialAction: ColoringCatDetails.initialAction,
  },
  {
    path: "/coloring-pages-printables/image/:any/",
    element: <ColoringDetails />,
    initialAction: ColoringDetails.initialAction,
  },
  {
    path: "/coloring-pages-printables/:any/:any/",
    element: <ColoringSubCatDetails />,
    initialAction: ColoringSubCatDetails.initialAction,
  },
  {
    path: "/tools/capture-baby-moments",
    element: <Face />,
    initialAction: Face.initialAction,
  },
  {
    path: "/tools/capture-baby-moments/uploadfaces",
    element: <UploadFaces />,
    initialAction: UploadFaces.initialAction,
  },
  {
    path: "/tools/capture-baby-moments/uploadfaces",
    element: <UploadFaces />,
    initialAction: UploadFaces.initialAction,
  },
  {
    path: "/tools/capture-baby-moments/slide-show",
    element: <SlideShow />,
    initialAction: SlideShow.initialAction,
  },

  // {
  //   path: /^\/coloring-pages-printables\/image\/w*(?!no-result-found)[a-zA-Z0-9._-]+\/$/,
  //   element: <ColoringDetails />,
  //   initialAction: ColoringDetails.initialAction,
  // },
  // {
  //   path: /^\/coloring-pages-printables\/w*(?!image|no-result-found)[a-zA-Z0-9._-]+\/$/,
  //   element: <ColoringCatDetails />,
  //   initialAction: ColoringCatDetails.initialAction,
  // },
  // {
  //   path: /^\/coloring-pages-printables\/w*(?!image|no-result-found)[a-zA-Z0-9._-]+\/w*[a-zA-Z0-9._-]+\/$/,
  //   element: <ColoringSubCatDetails />,
  //   initialAction: ColoringSubCatDetails.initialAction,
  // },
  {
    path: "/experts/",
    element: <ExpertListing />,
    initialAction: ExpertListing.initialAction,
  },
  {
    path: "/experts/:any/:any/:id/",
    element: <ExpertDetail />,
    initialAction: ExpertDetail.initialAction,
  },
  {
    path: "/experts/memories/:id/",
    element: <ExpertMemories />,
    initialAction: ExpertMemories.initialAction,
    // ExpertMemories
  },
  {
    path: "/tools/baby-growth-tracker-chart/",
    element: <GrowthTracker />,
    initialAction: GrowthTracker.initialAction,
  },
  {
    path: "/tools/vaccine-immunization-tracker/",
    element: <VaccinationTracker />,
    initialAction: VaccinationTracker.initialAction,
  },
  {
    path: "/tools/vaccine-immunization-tracker/feedback/",
    element: <Feedback />,
    initialAction: VaccinationTracker.initialAction,
  },
  {
    path: "/tools/baby-growth-tracker-chart/feedback/",
    element: <Feedback />,
    initialAction: VaccinationTracker.initialAction,
  },
  {
    path: "*",
    element: <NoPageFound />,
    initialAction: NoPageFound.initialAction,
  },
];


export default routes;